/**
 * Application configuration.
 */

/**
 * The name of the website.
 */
export const siteName = "nisavid.io";

/**
 * The key under which the persistent state is stored.
 */
export const stateStorageKey = "state";

/**
 * The ID of the root element for the Elm application.
 */
export const elmRootId = "root";
